import { type SupportedLocale, supportedLocales } from "@site-types/content"

export const defaultLocale = "ja" satisfies SupportedLocale

export function isSupportedLocale(value: string | undefined): value is SupportedLocale {
  return supportedLocales.includes(value as SupportedLocale)
}

export function localeFromPathname(pathname: string): SupportedLocale {
  const firstSegment = pathname.split("?")[0]?.split("#")[0]?.split("/").filter(Boolean)[0]
  return isSupportedLocale(firstSegment) ? firstSegment : defaultLocale
}

/** Swap (or add) the locale segment of a path: `localizedPath("/ja/news", "en")` -> `/en/news`. */
export function localizedPath(path: string, locale: SupportedLocale): string {
  const url = new URL(path || "/", "https://playbrain.com")
  const parts = url.pathname.split("/").filter(Boolean)
  if (isSupportedLocale(parts[0])) parts[0] = locale
  else parts.unshift(locale)
  return `/${parts.join("/")}`.replace(/\/+$/, "") || `/${locale}`
}
